import { RouterManager } from '@aclass/admin/managers';
import { AclStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class AclStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:acl-init';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<boolean | null>(['aclModule', 'initialized']).pipe(filter(v => v));
        this.employee = this.routerManager.onRejectNavigation(AclStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(AclStory.dryRun());
    }
}
